document.addEventListener( 'DOMContentLoaded', function () {
  const progressBar = document.querySelector( '.progress-bar' );

  if ( progressBar ) {
    progressBar.classList.add( 'e-div--progressbar' );

    if ( !progressBar.querySelector( '.progress-fill' ) ) {
      const fill = document.createElement( 'div' );
      fill.className = 'progress-fill';
      progressBar.appendChild( fill );
    }
  }
} );

document.addEventListener( 'scroll', () => {
  const content = document.querySelector( '.entry-content' );
  const progressFill = document.querySelector( '.e-div--progressbar .progress-fill' );
  if ( !content || !progressFill ) return;

  const children = content.children;
  if ( children.length < 2 ) return;

  const lastIncluded = children[children.length - 2];

  const scrollTop = window.scrollY;
  const contentTop = content.offsetTop;
  const windowHeight = window.innerHeight;

  const contentEnd = lastIncluded.offsetTop + lastIncluded.offsetHeight;
  const totalScrollable = contentEnd - contentTop - windowHeight;
  const scrolled = Math.min(
    ( ( scrollTop - contentTop ) / totalScrollable ) * 100,
    100
  );

  progressFill.style.width = scrolled >= 0 ? `${scrolled}%` : '0%';
} );
